export default "__VITE_ASSET__B8WuijR0__"